import React, { useState, useEffect } from "react";
import { Form, Drawer, Button, Select, Table, List, InputNumber, Empty } from "antd";
import CartItem from "../components/items/CartItem";
import { useDispatch, useSelector } from "react-redux";
import { CloseCircleFilled } from "@ant-design/icons";
import {
  selectCart,
  selectModalCart,
  setModalCart,
} from "../app/features/cart";
import AgencyItem from "./items/AgencyItem";
import { Link } from "react-router-dom";

export default function DrawerCart({ dataChoose, onChange, refesh }) {
  const dispatch = useDispatch();
  const open = useSelector(selectModalCart);
  const cart = useSelector(selectCart);

  const onClose = () => {
    dispatch(setModalCart(false));
  };


  const renderItem = (item, index) => (
    <div key={index}>
      <AgencyItem data={item} />
      <div className="mt-6 grid gap-6">
        {item.drugs?.map((_item, _index) => (
          <>
            <CartItem data={_item} key={_index} action />
            {_index != item.drugs.length - 1 && <div className="h-[1px] bg-[#E1E1E1] w-full"></div>}
          </>
        ))}
      </div>

    </div>
  );

  return (
    // <div className="w-[700px] flex flex-1">
    <Drawer
      closable={false}
      placement="right"
      onClose={onClose}
      open={open}
      width={window.innerWidth > 900 ? 700 : '100%'}
      bodyStyle={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        padding: 0,
      }}
    >
      <div className="flex justify-between items-center  text-xl font-extrabold p-6">
        GIỎ HÀNG
        <Button
          type="link"
          onClick={onClose}
          className="flex items-center text-black text-lg p-0"
        >
          <CloseCircleFilled />
        </Button>
      </div>
      {cart?.length == 0 ? <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        imageStyle={{
          height: 60,
        }}
        description={
          <span>
            Không có sản phẩm nào trong giỏ hàng của bạn.
          </span>
        }
      >

      </Empty> : null}

      <div className="grid gap-4 py-2 sm:px-6 px-4">
        {cart?.map(renderItem)}
      </div>
      <div className="flex flex-1">
        <Link
          to="/cart"
          className={"self-end m-6 bg w-full h-[45px] bg-main-blue font-bold text-white rounded-3xl items-center flex justify-center " + `${cart?.length == 0 ?"disabled-link" : ""}`}
          onClick={onClose}
        >
          THANH TOÁN
        </Link>
      </div>
    </Drawer>
    // </div>
  );
}
